import { FC, useMemo } from 'react';
import { styled } from '@mui/material/styles';

import Button from 'src/presentations/components/atom/button';
import Modal from '../../molecules/modal';
import { IModalUpdateBaseProps, ROW_ACTION_TYPE } from './types';
import { useInternalDashboardSelector } from './Selector';
import { FormContainer } from '../forms/FormContainer';
import { IModalProps } from '../../molecules/modal/Modal';

interface IStyledModalProps extends IModalProps {
  size?: 'large' | 'medium' | 'small';
}

const CustomModal = (props: IStyledModalProps) => <Modal {...props} />;

export const StyledModal = styled(CustomModal)((props: IStyledModalProps) => ({
  zIndex: 999,

  '& .MuiDialog-paper': {
    maxWidth: props?.size === 'large' ? '800px' : props?.size === 'small' ? '35%' : '540px',
    borderRadius: '16px',
  },
  '& .MuiDialogContent-root': {
    padding: 0,
  },
}));

export const ModalUpdateBase: FC<IModalUpdateBaseProps> = (props) => {
  const { actionType, title, onSubmit, children, formContext } = props;
  const { isActionLoading, rowActionType, checkRowAction, stopRowAction } = useInternalDashboardSelector();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const isOpen = useMemo(() => checkRowAction(actionType), [actionType, rowActionType]);

  return (
    <StyledModal
      open={isOpen}
      title={title}
      fullWidth
      onClose={stopRowAction}
      size={
        actionType === ROW_ACTION_TYPE.EDIT_INVOICE || actionType === ROW_ACTION_TYPE.EDIT_OCR || ROW_ACTION_TYPE.VALIDATE_INVOICE
          ? 'large'
          : actionType === ROW_ACTION_TYPE.REPROCESS_SHIPMENT
            ? 'small'
            : 'medium'
      }
    >
      <div className='px-24 pb-24'>
        <FormContainer context={formContext} onSuccess={onSubmit}>
          <>{children}</>
          <div className='mt-48 grid gap-16 grid-cols-2 grid-rows-1 mt-40'>
            <Button variant='secondary' isFull disabled={isActionLoading} onClick={stopRowAction}>
              Cancel
            </Button>
            <Button type='submit' variant='primary' isFull isLoading={isActionLoading}>
              Save
            </Button>
          </div>
        </FormContainer>
      </div>
    </StyledModal>
  );
};
